import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import {environment} from "./environments/environment.development";
/**
 * Eliminar logs de la consola en modo de producción.
 */
if (environment.production) {
    window.console.log = () => {}
}
platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
